import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { MuiMaterials } from "../../@index.js";
import { getWindowChromeThemeColor } from "./windowChromeTheme.js";

/**
 * Compact "?" control for explanatory help. Prefer this over inline help sentences.
 */
export default function InfoHint({
    title,
    ariaLabel = "More information",
    placement = "top",
    size = "small",
    sx,
    iconSx,
}) {
    if (!title) return null;

    const color = getWindowChromeThemeColor("#666666", "#c4a574");

    return (
        <MuiMaterials.Tooltip
            title={title}
            arrow
            placement={placement}
            enterDelay={200}
            componentsProps={{
                tooltip: {
                    sx: {
                        maxWidth: 320,
                        fontSize: 12,
                        lineHeight: 1.4,
                    },
                },
            }}
        >
            <MuiMaterials.IconButton
                size={size}
                aria-label={ariaLabel}
                tabIndex={0}
                sx={{
                    color,
                    p: 0.25,
                    flexShrink: 0,
                    ...sx,
                }}
            >
                <HelpOutlineIcon fontSize="small" sx={iconSx} />
            </MuiMaterials.IconButton>
        </MuiMaterials.Tooltip>
    );
}
